import React, { Component } from 'react'
import Link from 'gatsby-link'
import {Title} from '../Title'
import {InfoBlockGrid} from '../InfoBlockGrid'

import './support-letters.css'

const nLettersPerRow = 2;
const nLettersPerRowMobile = 1;
const descriptionStyleMod = {fontSize: '12'};

class SupportLetters extends Component {

  render () {
    let data = this.props.data;
    let title = data.title ? <Title name = {data.title}></Title> : null;

    return (
      <div>
        {title}
        <InfoBlockGrid
          nCellsPerRow = {nLettersPerRow}
          nCellsPerRowMobile = {nLettersPerRowMobile}
          descriptionStyleMod = {descriptionStyleMod}
          hasModalImage={true}
          data = {data.letters}
          sizes = {this.props.sizes}
        ></InfoBlockGrid>

      </div>
    );
  }
}


export default {SupportLetters}



// WEBPACK FOOTER //
// ./src/components/SupportLetters/index.js